export default __webpack_public_path__ + "static/media/bg-3.f44cfab9.jpg";